import {
  Card,
  Descriptions,
  Label,
  Space,
  Text,
  WithPopover,
} from '@procurify/ui'

import {
  type CreditCardVendorEnum,
  CreditCardVendors,
} from '@webapp/core/entities/external/CreditCardVendor'
import { useFormatCreditCardTypeToLabel } from '@webapp/core/hooks/useFormatCreditCardTypeToLabel/useFormatCreditCardTypeToLabel'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { CreditCardIcon } from '../CreditCardIcon'

export interface ICreditCardLabelProps {
  type?: CreditCardVendorEnum
  name?: string
  last4Digits?: string
}

export const CreditCardLabel = ({
  type = CreditCardVendors.OTHER,
  name,
  last4Digits,
}: ICreditCardLabelProps) => {
  const intl = useProcurifyIntl()
  const formatTypeToLabel = useFormatCreditCardTypeToLabel()

  return (
    <WithPopover
      content={
        <Card.Content>
          <Space>
            <Space direction='horizontal'>
              <CreditCardIcon type={type} height='30px' />
              <Text>{name || formatTypeToLabel(type)}</Text>
            </Space>

            <Descriptions size='small' valueAlign='right' valueWidth={'fill'}>
              <Descriptions.Item label='Type'>
                {formatTypeToLabel(type)}
              </Descriptions.Item>
              <Descriptions.Item
                label={intl.formatMessage(messages.last4Digits)}
              >
                {last4Digits}
              </Descriptions.Item>
            </Descriptions>
          </Space>
        </Card.Content>
      }
      trigger={'hover'}
      placement='top'
    >
      <Label component={<CreditCardIcon type={type} height='30px' />}>
        <Text textEllipsis>{name || formatTypeToLabel(type)}</Text>
      </Label>
    </WithPopover>
  )
}
